import EventTeaser from 'components/Teasers/Event'
import Link from 'components/Navigation/WrapperLink'
import SliderContainer from 'components/SliderContainer'
import styles from './EventList.module.scss'

export default function EventList({ section }) {
  const { events, showBtn, carousel = false } = section

  if (events.length === 0) {
    return null
  }

  return (
    <section className={styles.section}>
      <div className="container">
        {carousel ? (
          <SliderContainer events={events} />
        ) : (
          <div className={styles.wrap}>
            {events.map((event) => (
              <EventTeaser key={event.id} event={event} />
            ))}
          </div>
        )}

        {showBtn && (
          <div className={styles.btnWrap}>
            <Link data={{ slug: '/tapahtumat', type: 'event_archive' }}>
              <button className="btn btn--secondary btn--pink btn--large">
                Kaikki tapahtumat
              </button>
            </Link>
          </div>
        )}
      </div>
    </section>
  )
}
